<div class="text-base">
  Publicerad: {{ publishDate() }}<br>
  Uppdaterad: {{ updateDate() }}
</div>

@if (hasAuthors()) {
  <div class="text-base">
    Författare:
    @for (authorItem of authorsToDisplay(); track trackById($index, authorItem); let last = $last) {
      <span class="inline">
        <a [innerHTML]="authorItem.display_name" [routerLink]="authorItem.routerLink"></a>
        @if (!last || hasAuthorName()) {
          ,
        }
      </span>
    }
    @if (hasAuthorName()) {
      <span class="inline">{{ authorName() }}</span>
    }
  </div>
} @else if (hasAuthorName()) {
  <div class="text-base">
    Författare: {{ authorName() }}
  </div>
}

@if (hasFactChecker()) {
  <div class="text-base">
    Faktagranskad av:
    <span class="inline" [innerHTML]="factChecker() | wpMediaUrlFix | safeHtml"></span>
  </div>
}
